export default function({ client_id, client_secret }) {
    return `
    $ch = curl_init('https://sandbox.sasapay.app/oauth/v1/generate?grant_type=client_credentials');
    curl_setopt($ch, CURLOPT_HTTPHEADER, [
      'Authorization: Basic ' . base64_encode('${client_id}:${client_secret}')
    ]);
    curl_setopt($ch, CURLOPT_SSL_VERIFYPEER, false);
    $response = curl_exec($ch);
    echo json_decode($response);
  `;
}